module.exports = __webpack_public_path__ + "static/media/mainimg-08.011ae70d.png";